export type UseIsPurchaseDisabledDueToCrossPlatformType = () => boolean;

export const useIsPurchaseDisabledDueToCrossPlatform: UseIsPurchaseDisabledDueToCrossPlatformType =
  () => false;
